module.exports = __webpack_public_path__ + "img/social-icon-instagram.3637f883.svg";